import React, { Component } from 'react';
import 'react-bootstrap';

import store from '../../store/configureStore';
import SpecialBlock from './SpecialBlock';
import { lang } from '../../config/lang';
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from '../../actions/topBannerAction';
import { changeActiveItemAction } from '../../actions/navAction';
import { Businesses, PagesForCaption, CaptionCodes } from '../../config/Helper';
import captionApi from '../../api/captionApi';
import specialApi from '../../api/specialApi';
import GoodsBlock from './GoodsBlock';
import NoData from '../../components/NoData';
import Pagination from '../../components/pagination/Pagination';
import $ from "jquery/dist/jquery.js";
import ScrollToTop from '../home/ScrollToTop/ScrollToTop';

/****************************************
    Component for special page
    @author  UYM
    @date    2020.05.15
    @version 0.1    
 ******************************************/
class SpecialList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lastPage: 1,
            arrArticles: [],
            title: '',
            business: Businesses.indexOf('special'),
            perPage: 12
        }
        this.paginate = {
            currentPage: 1,
            // lastPage: 1,
            visible: 6
        }
        this.perPage = 8
        this.load = this.load.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onPerPageChange = this.onPerPageChange.bind(this);


    }

    componentWillMount() {
        store.dispatch(changeActiveItemAction(Businesses.indexOf('special')));
        store.dispatch(changeTopBannerAction({
            page: 'special',
            showSearch: false,
            isHome: false
        }));
        this.load();
    }

    componentDidMount() {
        this.load();
        window.onClose();
        window.gallery();
        window.onSetClass('light');
        window.scrollTop('#top_banner');
        this.perPage = $('#special_perpage_selector').val()
    }

    componentWillUnmount() {
        this.perPage = $('#special_perpage_selector').val()
    }

    componentDidUpdate() {
        window.onClose();
    }

    componentWillReceiveProps(newProps) {
        this.load();
        this.perPage = $('#special_perpage_selector').val()
    }

    load() {
        var caption = '';

        // captionApi.getCaptions('special').then((json) => {        
        //     if (json.status === 200) {  
        //         caption = json.data[CaptionCodes[PagesForCaption.indexOf('special')].indexOf('special_list')];
        //     } else {
        //         // store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
        //     }            
        // })

        specialApi.getAll(this.paginate.currentPage, this.perPage).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    title: (caption === undefined || caption.title === undefined || caption.title === null) ? "" : caption.title,
                    arrArticles: json.data,
                    currentPage: json.data.currentPage,
                    lastPage: json.data.lastPage,
                    total: json.data.total
                })
                // this.stylizeFooter();
            } else {
                if (json.status === 620) {
                    store.dispatch(addNotification(`${lang('access_deny')}`, 'error'));
                } else {

                }
            }
        })
    }
    onChangePage(page) {
        this.paginate.currentPage = page;
        this.props.history.push("/special" + "?" + "page=" + page)
        this.load();
    }
    onPerPageChange() {
        this.setState({
            perPage: $('#special_perpage_selector').val()
        })
        this.perPage = $('#special_perpage_selector').val()
        this.load();
    }
    render() {
        return (
            <div>
                <div className='select-perpage'>
                    <select className="form-control rounded" name="" id="special_perpage_selector" onChange={this.onPerPageChange}>
                        <option value={8} key={1}>8</option>
                        <option value={12} key={2}>12</option>
                        <option value={16} key={3}>16</option>
                    </select>
                </div>

                <section className="ftco-section" id="mediaListSection">
                    <div className="container">
                        <div className="row flex-column align-items-center">
                            <div className="mt-3 mb-3">
                            {`${lang('total')}` + this.state.total}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 pr-lg-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        {
                                            this.state.arrArticles.data &&
                                            this.state.arrArticles.data.map((singleArticle, key) => (
                                                <div className="post-box col-12 col-sm-6 col-md-4 col-lg-3 " data-animate-effect="fadeIn" key={key}>
                                                    <GoodsBlock
                                                        business={this.state.business}
                                                        id={Number(singleArticle.id)}
                                                        title={singleArticle.title}
                                                        image={singleArticle.medias.length && singleArticle.medias[0].name}
                                                        media_type={singleArticle.medias.length && singleArticle.medias[0].format}
                                                        currentPage={this.paginate.currentPage} />
                                                </div>

                                            ))
                                        }

                                        {
                                            this.state.arrArticles && this.state.arrArticles.length === 0 &&
                                            <NoData />
                                        }
                                    </div>
                                </div>

                                <section className='select-selection'>
                                    <div className="container">
                                        <div className="row justify-content-center pb-5">
                                            <div className="block-27">
                                                {
                                                    this.state.arrArticles.data &&
                                                    this.state.arrArticles.data.length > 0 &&
                                                    <Pagination
                                                        total={this.state.lastPage}
                                                        curPage={this.state.currentPage}
                                                        visible={this.paginate.visible}
                                                        onChangePage={this.onChangePage}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <ScrollToTop />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(SpecialList);